import api from '../utils/api';
import {
  PERFORMANCE_DATA_FAILED,
  PERFORMANCE_DATA_SUCCESS,
  REQUEST_PERFORMANCE_DATA,
} from './types';

export const loadPerformance = (params) => async (dispatch) => {
  try {
    dispatch({ type: REQUEST_PERFORMANCE_DATA });
    const { data } = await api.get(`/data/performance?${params}`);
    console.log(data);
    dispatch({ type: PERFORMANCE_DATA_SUCCESS, payload: data.data });
  } catch (error) {
    console.log(error);
    dispatch({ type: PERFORMANCE_DATA_FAILED });
  }
};


export const clearPerformance = () => async (dispatch) => {
  try {
    dispatch({ type: PERFORMANCE_DATA_SUCCESS, payload: null });
  } catch (error) {
    console.log(error);
  }
};
